import { Component } from '@angular/core';
import { StepItem, StepSummary } from '../../stepper/stepper.component';

@Component({
  selector: 'app-stepper-showcase',
  templateUrl: './stepper-showcase.component.html',
  styleUrls: ['./stepper-showcase.component.scss']
})
export class StepperShowcaseComponent {
  // Example 1: Default 4-step flow (matches the screenshot)
  defaultSteps: StepItem[] = [
    { id: 'submitters', title: 'Claim Submitters' },
    { id: 'method', title: 'Claiming Method' },
    { id: 'distribution', title: 'Distribution Method' },
    { id: 'reward', title: 'Select Reward Type' }
  ];

  defaultStepData: { [key: string]: StepSummary } = {
    submitters: { label: 'Claim Submitters', value: 'Seller Individuals', status: 'completed' },
    method: { label: 'Claiming Method', value: 'Quick Claiming', status: 'active' },
    distribution: { label: 'Distribution Method', value: undefined, status: 'disabled' },
    reward: { label: 'Select Reward Type', value: undefined, status: 'disabled' }
  };

  defaultCurrentStep = 1;

  // Example 2: Two-step flow
  minimalSteps: StepItem[] = [
    { id: 'info', title: 'Basic Info' },
    { id: 'review', title: 'Review' }
  ];

  minimalStepData: { [key: string]: StepSummary } = {
    info: { label: 'Basic Information', value: 'Form Completed', status: 'completed' },
    review: { label: 'Review Details', value: undefined, status: 'active' }
  };

  minimalCurrentStep = 1;

  // Example 3: All steps completed
  completedSteps: StepItem[] = [
    { id: 'step1', title: 'Step 1' },
    { id: 'step2', title: 'Step 2' },
    { id: 'step3', title: 'Step 3' }
  ];

  completedStepData: { [key: string]: StepSummary } = {
    step1: { label: 'Step 1', value: 'Complete', status: 'completed' },
    step2: { label: 'Step 2', value: 'Complete', status: 'completed' },
    step3: { label: 'Step 3', value: 'Complete', status: 'completed' }
  };

  completedCurrentStep = 3;

  // Example 4: Interactive flow with click navigation
  interactiveSteps: StepItem[] = [
    { id: 'account', title: 'Account' },
    { id: 'preferences', title: 'Preferences' },
    { id: 'confirmation', title: 'Confirmation' }
  ];

  interactiveCurrentStep = 0;

  get interactiveStepData(): { [key: string]: StepSummary } {
    const stepStates: { [key: string]: StepSummary } = {
      account: {
        label: 'Account Setup',
        value: this.interactiveCurrentStep > 0 ? 'Email Verified' : undefined,
        status: this.interactiveCurrentStep > 0 ? 'completed' : 'active'
      },
      preferences: {
        label: 'User Preferences',
        value: this.interactiveCurrentStep > 1 ? 'Notifications Enabled' : undefined,
        status: this.interactiveCurrentStep > 1 ? 'completed' : this.interactiveCurrentStep === 1 ? 'active' : 'disabled'
      },
      confirmation: {
        label: 'Final Confirmation',
        value: this.interactiveCurrentStep > 2 ? 'Confirmed' : undefined,
        status: this.interactiveCurrentStep > 2 ? 'completed' : this.interactiveCurrentStep === 2 ? 'active' : 'disabled'
      }
    };
    return stepStates;
  }

  onInteractiveStepClick(stepIndex: number): void {
    if (stepIndex <= this.interactiveCurrentStep) {
      this.interactiveCurrentStep = stepIndex;
    }
  }

  goToPreviousStep(): void {
    if (this.interactiveCurrentStep > 0) {
      this.interactiveCurrentStep--;
    }
  }

  goToNextStep(): void {
    if (this.interactiveCurrentStep < this.interactiveSteps.length - 1) {
      this.interactiveCurrentStep++;
    }
  }

  // Example 5: Value style variants
  variantSteps: StepItem[] = [
    { id: 'completed', title: 'Completed' },
    { id: 'active', title: 'Active' },
    { id: 'disabled', title: 'Disabled' }
  ];

  variantStepData: { [key: string]: StepSummary } = {
    completed: { label: 'Completed State', value: 'Success', status: 'completed' },
    active: { label: 'Active State', value: 'Processing', status: 'active' },
    disabled: { label: 'Disabled State', value: undefined, status: 'disabled' }
  };

  variantCurrentStep = 3;
}
